import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class ItemErrorService {
    private itemErrorDetails = new Map();
    private desiredTabOrder = [
        ItemTabName.Detail,
        ItemTabName.Price,
        ItemTabName.Budget,
        ItemTabName.Capital,
        ItemTabName.AddOn,
    ];
    getItemErrorDetails(): Map<number, any> {
        return this.itemErrorDetails;
    }

    getItemKeys() {
        const sortedKeys = Array.from(this.itemErrorDetails.keys()).sort((a, b) => a - b);
        return sortedKeys;
    }


    reorderObject(obj: any): any {
        const orderedObject: any = {};
        this.desiredTabOrder.forEach((key) => {
            if (obj[key] !== undefined) {
                orderedObject[key] = obj[key];
            }
        });
        return orderedObject;
    }


    getItemKeyValue(key: number) {
        return this.itemErrorDetails.has(key) ? this.reorderObject(this.itemErrorDetails.get(key)) : null;
    }

    setItemErrorDetails(key: number, property: string, values: Array<string>) {
        if (!this.itemErrorDetails.has(key)) {
            this.itemErrorDetails.set(key, { [property]: values });
        } else {
            const existingObject = this.itemErrorDetails.get(key);
            if (!existingObject[property]) {
                existingObject[property] = values;
            } else {
                values.forEach(value => {
                    if (!existingObject[property].includes(value)) {
                        existingObject[property].push(value);
                    }
                });
            }
        }
    }

    clearItemErrorDetails(keyToRemove?: number) {
        if (keyToRemove && this.itemErrorDetails.has(keyToRemove)) {
            this.itemErrorDetails.delete(keyToRemove);
        } else {
            this.itemErrorDetails.clear();
        }
    }

    //FY - to check item planned Delivey date is within FY or Future
    getCurrentFYEnd() {
        const currentDate = new Date();
        const currentFinanacialYear = currentDate.getFullYear();
        const currentDeliveryMonth = currentDate.getMonth();
        // If the current month is after March, the financial year ends on March 31 of the next year
        const FYEnd = currentDeliveryMonth >= 3 ? new Date(currentFinanacialYear + 1, 2, 31) : new Date(currentFinanacialYear, 2, 31);
        return FYEnd;
      }

}

export enum ItemTabName {
    Detail = 'Detail',
    Price = 'Price',
    Budget = 'Budget allocation',
    Capital = 'Capital usage requirements',
    AddOn = 'Add-on'
}

export enum ItemFieldName {
    //Detail
    ItemDesc = 'Item Description',
    MaterialGroup = 'Material group',
    MaterialSubGroup = 'Material sub group',
    Brand = 'Brand/OEM',
    Critical = 'Criticality Code',
    Workmanship = 'Workmanship standard',
    PartModelNum = 'part/model no',
    PlannedDeliveryDate = 'Planned delivery date',
    CotsCustomised = 'COTS/Customised',
    SMLDeviation = 'Reason for SML deviation',
    //Price
    UnitPrice = 'Unit price',
    Currency = 'Currency',
    UnitPerQuantity = 'Units per quantity',
    MeasurementUnit = 'Unit of Measurement',
    Quantity = 'Quantity',
    //Budget allocation
    BudgetType = 'Budget Type',
    CostCentre = 'Cost centre',
    GLAccount = 'G/L account',
    BudgetExpenditure = 'Budget expenditure',
    BudgetFrequency = 'Budget frequency',
    ProjectBudget = 'Project Budget',
    ProjectCode = 'Project code',
    FundCentre = 'Fund Centre',
    UnbudgetedSelected = 'Budget expenditure usage (Selection of Unbudgeted is not allowed)',
    //Capital
    EstUsageOfAsset = 'Estimated usage of asset',
    AdditionalSpace = 'Additional space allocation',
    AnnualMaintenance = 'Annual maintenance',
    ItemSupportCoFunding = 'Item support any projects that are not funding this purchase',
    ReasonCoFunding = 'Reasons for not funding this purchase',
    //Add-on
    Duration = 'Duration'
}